module.exports = __webpack_public_path__ + "media/images/athletes/2090-d14d0d55f2c00931a3b4bf902dbed388.png";